import HELPER from './HELPER';
import atom from '@/app/editor/iframe/atom';

/**
 * load Loop Items if Module is collection like Product List, Article List, ...
 * @param $element gfModule.$element
 * @param $gryffEditor gfModule.gryffEditor
 * @param moduleId gfModule.moduleId
 * @param moduleName gfModule.moduleName
 * @param html html
 * @param bkHtml bkHtml
 */
export default function loadLoopItems(
  $element: JQuery<HTMLElement>,
  $gryffEditor: JQuery,
  moduleId: string,
  moduleName: string,
  html: string,
  bkHtml: string,
) {
  const $loopItems = $element.find('.item-loop');
  const length = $loopItems.length;

  /**
   * load each item recursively
   * @param i index
   */
  const loadRecursive = function (i = 0) {
    if (i < length) {
      // in loop
      const $item = $loopItems.eq(i);

      const index: any = $item.data('index');
      const newChildId = `${moduleId}-child${index}`;
      const rData = HELPER.replaceIds(html, bkHtml, newChildId);

      html = rData.html;
      bkHtml = rData.bkHtml;

      // add data-index for module
      const $html = jQuery('<div />').html(html);

      if (moduleName == 'Product List' || moduleName == 'Related Products') {
        if ($html.find('[data-label="Product"]').length > 0) {
          $html.find('[data-label="Product"]').attr('data-index', index);
        }
      } else if (moduleName == 'Article List') {
        if ($html.find('[data-label="Article"]').length > 0) {
          $html.find('[data-label="Article"]').attr('data-index', index);
        }
      }

      // IMPROTANT UPDATE clear all image tags to improve performance
      $html.find('.item-content').html(' ');

      html = $html.html();

      /**
       * move to next item in $loopItems
       */
      const moveToNextItem = () => {
        $item.remove();
        // delay 100ms before move to next item
        setTimeout(function () {
          return loadRecursive(++i);
        }, 100);
      };

      if (i == 0) {
        // first item in $loopItems
        const replaceIds = false;
        if ($gryffEditor.data('gryffeditor') != undefined) {
          $gryffEditor.data('gryffeditor').addEditorContent(html, bkHtml, $item, moveToNextItem, replaceIds);
        }
      } else {
        // not first item in $loopItems
        $item.after(html);
        HELPER.addContentBk(bkHtml);
        atom.Init($item.next('.module-wrap'));
        moveToNextItem();
      }
    } else {
      // end loop
      const $el = $element.find('.module-wrap[data-label="(P) Title"], .module-wrap[data-label="(A) Title"]').eq(0);
      HELPER.flagListItemChange($el, 'settings');
      const $itemContent = $el.closest('.item-content');
      HELPER.detectContentChange($itemContent);

      $loopItems.remove();
    }
  };

  loadRecursive();
}
